import * as React from "react";
import { Box } from "@mui/material"

import DIPDateRange from "./DateRange"
import PageWrapperActionsRangeSelected from "./RangeSelected"


export default function PageWrapperActions({dateRangeProps}) {
    return <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', mb: -1}}>
            <PageWrapperActionsRangeSelected />
            <DIPDateRange {...dateRangeProps} />
        </Box>
    </Box>
}